import i18next from 'i18next';
import { firstLetterUpper } from './formatters';

export const treatCustomerName = (customerName: string | undefined): string => {
  if (customerName) {
    const splitCustomerName = customerName
      .split(' ')
      .filter(str => !['', '-', ','].includes(str));

    if (splitCustomerName.length === 1) {
      return firstLetterUpper(splitCustomerName[0]);
    }

    return `${firstLetterUpper(splitCustomerName[0])} ${
      splitCustomerName[1] ?? ''
    }`.trim();
  }
  return '';
};

const treatPathname = (pathname: string) =>
  pathname
    .split('/')
    ?.filter(item => item !== '')
    ?.slice(0, 3)
    ?.slice(-1)?.[0];

interface IChangeDocumentTitle {
  t: any;
  pathname: string;
  customerLoggedName?: string;
  detailName?: string;
  isAlgarDomain?: boolean;
}

export const changeDocumentTitle = ({
  t,
  pathname,
  customerLoggedName,
  detailName,
  isAlgarDomain,
}: IChangeDocumentTitle) => {
  const treatedPathname = pathname
    .replace('mobile-network/', '')
    .replace('lorawan/', '');
  const hasTranslate = i18next.exists(
    `main:tab-titles.${treatPathname(treatedPathname)}`,
  );

  const isPageHome = pathname === '/';

  const childPageTreat = treatedPathname.split('/').slice(2, 3);

  const hasTranslateChild = i18next.exists(`main:tab-titles.${childPageTreat}`);
  const childPage = hasTranslateChild ? childPageTreat[0] : 'not-found';

  let tabTitle = isAlgarDomain ? 'MoT' : '';
  if (treatedPathname !== '/') {
    tabTitle = t(
      `tab-titles.${hasTranslate ? treatPathname(treatedPathname) : childPage}`,
    );
  }

  const detailNamePath = detailName ? `${detailName} - ` : '';
  const pageHomePath = isPageHome && !isAlgarDomain ? '' : ' - ';
  const customerLoggedNamePath = customerLoggedName
    ? `${pageHomePath}${treatCustomerName(customerLoggedName)}`
    : '';

  document.title = `${detailNamePath}${tabTitle}${customerLoggedNamePath}`;
};
